// extracted by mini-css-extract-plugin
module.exports = {"maxGridWidth":"1940px"};